// extracted by mini-css-extract-plugin
module.exports = {"mobileFunds":"ReportsPage_mobileFunds__LRGgQ","desktopFundReports":"ReportsPage_desktopFundReports__2fS5E"};